<script setup lang="ts"></script>

<template>
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_2202_18259)">
      <path
        d="M20.5499 5.472V22.1C20.5499 23.177 19.6768 24.05 18.5999 24.05H5.4C4.32305 24.05 3.45 23.177 3.45 22.1V2.9C3.45 1.82304 4.32304 0.95 5.4 0.95H15.6267L20.5499 5.472Z"
        stroke="#D0D5DD"
        stroke-width="0.9"
      />
      <mask id="path-2-inside-1_2202_18259" fill="white">
        <path d="M15 1.10001H20.1V6.20001H15.6C15.2686 6.20001 15 5.93138 15 5.60001V1.10001Z" />
      </mask>
      <path
        d="M15 1.10001H20.1H15ZM20.1 6.80001H15.6C14.9373 6.80001 14.4 6.26275 14.4 5.60001H15.6H20.1V6.80001ZM15.6 6.80001C14.9373 6.80001 14.4 6.26275 14.4 5.60001V1.10001H15.6V5.60001V6.80001ZM20.1 1.10001V6.20001V1.10001Z"
        fill="#D0D5DD"
        mask="url(#path-2-inside-1_2202_18259)"
      />
      <rect x="0.600098" y="12.5" width="14.4" height="7.6" rx="1.2" fill="#F04438" />
      <path
        d="M5.68967 15.444C5.68967 15.688 5.63367 15.912 5.52167 16.116C5.40967 16.316 5.23767 16.478 5.00567 16.602C4.77367 16.726 4.48567 16.788 4.14167 16.788H3.50567V18.3H2.47967V14.088H4.14167C4.47767 14.088 4.76167 14.146 4.99367 14.262C5.22567 14.378 5.39967 14.538 5.51567 14.742C5.63167 14.946 5.68967 15.18 5.68967 15.444ZM4.06367 15.972C4.25967 15.972 4.40567 15.926 4.50167 15.834C4.59767 15.742 4.64567 15.612 4.64567 15.444C4.64567 15.276 4.59767 15.146 4.50167 15.054C4.40567 14.962 4.25967 14.916 4.06367 14.916H3.50567V15.972H4.06367ZM7.80181 14.088C8.24581 14.088 8.63381 14.176 8.96581 14.352C9.29781 14.528 9.55381 14.776 9.73381 15.096C9.91781 15.412 10.0098 15.778 10.0098 16.194C10.0098 16.606 9.91781 16.972 9.73381 17.292C9.55381 17.612 9.29581 17.86 8.95981 18.036C8.62781 18.212 8.24181 18.3 7.80181 18.3H6.22381V14.088H7.80181ZM7.73581 17.412C8.12381 17.412 8.42581 17.306 8.64181 17.094C8.85781 16.882 8.96581 16.582 8.96581 16.194C8.96581 15.806 8.85781 15.504 8.64181 15.288C8.42581 15.072 8.12381 14.964 7.73581 14.964H7.24981V17.412H7.73581ZM13.3252 14.088V14.91H11.6092V15.798H12.8932V16.596H11.6092V18.3H10.5832V14.088H13.3252Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_2202_18259">
        <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss"></style>
